import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function ResetPasswordPage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setIsLoading(true);

        try {
            const res = await fetch('https://geometryhustlers.pl/wp-json/wp/v2/users/reset-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            const data = await res.json();

            if (res.ok) {
                navigate('/login?passwordSent=success');
            } else {
                setError(data.message || 'Wystąpił błąd podczas wysyłania linku resetującego');
            }
        } catch (e) {
            setError('Błąd połączenia z serwerem. Spróbuj ponownie.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-page">
        <div style={{ maxWidth: '500px', margin: '0 auto' }}>
        <div className="auth-form-panel">
        <h2 className="auth-form-title">Resetuj hasło</h2>
        <p className="auth-benefits-subtitle">
        Podaj adres email powiązany z kontem. Wyślemy Ci link do resetowania hasła.
        </p>

        {/* Komunikaty systemowe */}
        {error && <div className="alert alert-error">{error}</div>}
        {message && <div className="alert alert-success">{message}</div>}

        <form onSubmit={handleSubmit}>
        <div className="auth-form-group">
        <label className="auth-form-label">Adres e-mail</label>
        <input
        type="email"
        className="auth-form-input"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
        disabled={isLoading}
        />
        </div>

        <button
        className="auth-submit-btn"
        type="submit"
        disabled={isLoading}
        >
        {isLoading ? 'WYSYŁANIE...' : 'WYŚLIJ LINK RESETUJĄCY'}
        </button>
        </form>

        <Link to="/login" className="auth-forgot-link">
        ← Powrót do logowania
        </Link>
        </div>
        </div>
        </div>
    );
}

export default ResetPasswordPage;
